import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonModal, CustomPagination } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { AddEditVendors, AddEditZoneModal } from 'modals';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';

const Zone = () => {
  useDocumentTitle("Zone | T360");

  const { settingChild } = useContext(UserContext);
  const settingChildZone = settingChild?.find((i) => i?.label === "Zone");
  const [isOpenZoneModal, setIsOpenZoneModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [zoneList, setZoneList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const prevFilterRef = useRef();
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    status: 1
  });

  const toggleZoneModal = () => {
    setIsOpenZoneModal(!isOpenZoneModal);
  };

  const getDataZoneList = async () => {
    try {
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
      }
      const res = await getZoneListData(object);
      if (res?.responseCode == 200) {
        setZoneList(res?.data?.zone_list);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    }
  }

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getDataZoneList();
      prevFilterRef.current = filter;
    }

  }, [filter, isOpenZoneModal])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteConsignor = async () => {
    setLoading(true);
    try {
      let object = {
        company_id: isDelete?.company_id,
        zone_id: isDelete?._id,
      }
      const res = await deleteZoneData(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataZoneList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.error('Error !! ');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteConsignor,
    isLoadding: loading,
  }

  let openZoneModal = {
    isOpen: isOpenZoneModal,
    closeModal: (e) => setIsOpenZoneModal(false),
    // nextModal: (e) => submitUpdateData(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: isOpenZoneModal?.view ? "View Zone" : isOpenZoneModal?.edit ? "Edit Zone" : 'Add Zone',
    submitTitle: isOpenZoneModal?.view ? "View Zone" : isOpenZoneModal?.edit ? "Update Zone" : 'Add Zone',
    footerPart: true,
    ApiCall: getDataZoneList
  }

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Zone Name", accessor: "zone" },
    // { header: "Number of Unit", accessor: "number_of_unit" },
    // { header: "Number of Consignee", accessor: "number_of_consignee" },
    { header: "Status", accessor: "status" },
    { header: "Action", accessor: "action" }
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      // serial: <>{i + 1 + filter?.limit * (filter?.page - 1)}</>,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">
            {settingChildZone?.view === 1 && <Link
              className='_avPointer'
              onClick={(e) => setIsOpenZoneModal({ ...item, view: true })}
              style={{ textDecoration: 'none' }}
            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye />
                </span>View
              </span>
            </Link>}

            {/* {settingChildZone?.edit === 1 && <div
            onClick={(e) => setIsOpenZoneModal({...item,edit:true})}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit />
                </span>
                Edit
              </span>
            </div>} */}

            {settingChildZone?.delete === 1 && <div
              onClick={(e) => deleteHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
                Delete
              </span>
            </div>}
          </div>
        </div>
      </>,
      zone: <>{item?.name ? item?.name : '-'}</>,
      number_of_unit: <>{item?.contact_nunber ? item?.contact_nunber : '-'}</>,
      number_of_consignee: <>{item?.consignor_group_id?.name ? item?.consignor_group_id?.name : '-'}</>,
      status: <div style={{ color: item?.active ? "green" : "red" }}>  {item?.active ? constant.activeArray[item?.active] : '-'} </div>,
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          {settingChildZone?.view === 1 && <Link
            className='_avPointer'
            onClick={(e) => setIsOpenZoneModal({ ...item, view: true })}
            style={{ textDecoration: 'none' }}
          >
            <span className='_samAnchor'>
              <span className='viewIcon_avt'>
                <AiOutlineEye color='green' />
              </span>
            </span>
          </Link>}

          {/* {settingChildZone?.edit === 1 && <div
            onClick={(e) => setIsOpenZoneModal({...item,edit:true})}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit color='blue'/>
                </span>
                
              </span>
            </div>} */}

          {settingChildZone?.delete === 1 && <div
            onClick={(e) => deleteHandler(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='deleteIcon_avt'>
                <FaRegTrashCan color='red' />
              </span>

            </span>
          </div>}
        </div>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  return (
    <div className="__profilCmp_main setting-nw-parentBx">
      <ButtonHeading
        title={"Zone"}
        onClick={toggleZoneModal}
        buttonTitle={settingChildZone?.create === 1 && "Add Zone"}
        className="commonHeading_title"
        showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={true}
      />

      <div className='_tabWith_outTab'>
        <BootstrapTable
          tableClass="nrml-tbl"
          columns={columns}
          data={rowListData(zoneList?.length > 0 ? zoneList : [])}
          isLoading={loading}
        />

        {zoneList?.length > 0 && <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div>}
      </div>

      {
        isOpenZoneModal
        && (
          <AddEditZoneModal {...openZoneModal} />
        )
      }

      {
        isDelete?.company_id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
      >
        {showFilterModal &&
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        }
      </div>
      <div className={showFilterModal ? 'offBack_drop' : ''}></div>

    </div>
  )
}

export default Zone